import React, { forwardRef } from 'react';

import MUITextField, {
  TextFieldProps as MUITextFieldProps,
} from '@material-ui/core/TextField';

type TextFieldProps = MUITextFieldProps;

const TextField = forwardRef<HTMLParagraphElement, TextFieldProps>(
  (props, ref) => {
    return <MUITextField {...props} ref={ref} />;
  }
);

TextField.displayName = 'TextField';

export default TextField;
